export default {
    accept_payments_for_nonclosed_visit: "Визит жабык болбосо, төлөмдү кабыл алууга уруксат берүү",
    accountingmonth: "Бухгалтердик ай",
    accrual: "Эсептөө",
    accruals: "Эсептөөлөр",
    accrued: "Эсептелген",
    AQSI_account: "AQSI эсеби",
    balance_end: "Мезгилдин аягына карата баланс",
    balance_start: "Мезгилдин башына каратабаланс",
    bonus_movement: "Бонустардын кыймылы",
    cash_movements: "Акча агымы",
    cash_received: "Алынган акча каражаттар",
    closed: "Жабык",
    communal: "Коммуналдык төлөмдөр",
    deduct_materials_from_doctor_salary: "Дарыгердин эмгек акысынан материалдардын суммасын алып салуу",
    deduction: "Кармап алуу",
    deposit_account: "Депозиттик эсеп",
    deposit_accounts: "Депозиттик эсептер",
    deposit_balance: "Депозиттик калдык",
    deposit_balance_end: "Мезгилдин аягына карата депозиттик калдык",
    deposit_balance_start: "Мезгилдин башына карата депозиттик калдык",
    deposit_movement: "Депозиттик кыймылдар",
    employee: "Кызматкер",
    employee_id: "Кызматкердин ID",
    expense: "Чыгым",
    first_payment: "Биринчи төлөм",
    fiscal_cashdesk: "Фискалдык касса",
    for_payment_scan_this_qr_in_kyrgyz_bank: "Төлөө үчүн бул QR кодун сканерлеп, Кыргызстандын каалаган банкына төлөңүз",
    for_payment_scan_this_qr_in_obank_application: "Төлөө үчүн OBank тиркемесинде бул QRди сканерлеңиз",
    income: "Кирешелер",
    left_to_pay: "Төлөөгө калды",
    left_to_pay2: "Төлөөгө калды",
    manual_adjustments: "Кол менен тууралоо",
    materials_cost: "Материалдардын баасы",
    materials_expense: "Сарпталуучу материалдар",
    open: "Ачуу",
    opened: "Ачык",
    other_expense: "Башка чыгымдар",
    other_income: "Башка чыгымдар",
    pay_out: "Төлөп берүү",
    payment_comment: "Төлөмгө комментарий",
    payment_completed_successfully: "Төлөм ийгиликтүү аяктады",
    payment_sum: "Төлөө үчүн сумма",
    profit: "Киреше",
    recalculate: "Кайра санап чыгуу",
    refund_to_patient: "Бейтапка кайтаруу",
    rent: "Ижара",
    salaries: "Эмгек акылар",
    unclosed: "Жабык эмес",
    upselling: "Түгөтүп сатуу"
}
